module.exports = __webpack_public_path__ + "static/media/monthly_player@2x.157d7307.png";